import TopBar from "../Menu/TopMenu";
import { useEffect, useState } from "react";
import { GetSqsStatus } from "../../API/Axios";
import DataTable from "react-data-table-component";
import LoadingSpin from "../../common/Spinner";
import { Button, Card } from "react-bootstrap";

const CommonTable = ({ data }) => {

  const columns = [
    {
      id: "sqsid",
      name: "SQS Id",
      selector: (row) => row.VENDOR_NAME,
      sortable: true,
      width: "20%",
      style: {
        fontSize: "14px",
      },
    },
    {
      id: "READY",
      name: "Ready",
      selector: (row) => row.STATUS,
      sortable: true,
      width: "20%",
      style: {
        fontSize: "14px",
      },
    },
    {
      id: "IN_PROGRESS",
      name: "In Progress",
      selector: (row) => row.FAILURE_COUNT,
      sortable: true,
      width: "30%",
      style: {
        fontSize: "14px",
      },
    },
    {
      id: "FINISHED",
      name: "Success",
      selector: (row) => row.EXCEPTION,
      sortable: true,
      width: "30%",
      style: {
        fontSize: "14px",
      },
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },

    tableWrapper: {
      style: {
        border: "1px solid #ddd",
        borderRadius: "5px",
      },
    },
  };
  return (<>

    {data.length > 0 && (
      <div style={{ flex: 1 }}>
        <DataTable
          className="mt-2"
          bordered
          striped
          highlightOnHover
          columns={columns}
          data={data}
          customStyles={customStyles}
          responsive
          fixedHeader
          fixedHeaderScrollHeight="375px"
        />
      </div>
    )}
  </>);
};


const SqsStatus = () => {

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await GetSqsStatus();
      console.log("sqs status data = ", response);
      setData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const firstFiveRecords = data.slice(0, 5);
  const remainingRecords = data.slice(5);

  return (
    <div style={{ overflowY: 'auto', marginTop: '20px', width: '100%' }}>
      <TopBar pageTitle={"SQS Status"} />
      {isLoading ? (
        <LoadingSpin height={"450px"} width={"100%"} />
      ) : (
        <Card>
          <Card.Body>
            <div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' ,marginBottom:'10px' , marginTop:'10px'}} >
                <h5 >OTP</h5>
                <h5  style={{marginLeft:'48%'}}>NON-OTP</h5>
                <Button
                  style={{ height: '30px' , marginLeft:'auto'}}
                  variant="dark"
                  size="m"
                  className="d-flex justify-content-center align-items-center"
                  onClick={getData}
                >
                  Refresh
                </Button>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', width: '100%' }}>
                <CommonTable data={firstFiveRecords} isLoading={isLoading} />
                <CommonTable data={remainingRecords} isLoading={isLoading} />
              </div>
            </div>
          </Card.Body>
        </Card>
      )}

    </div>
  );
}

export default SqsStatus;
